import React from 'react';
import Element from '../../../../components/element';
import ReactHtmlParser from 'html-react-parser';

class SingleText extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: ''
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const { rawAnswers, checkSurveyState } = this.props;
    if (rawAnswers) {
      this.setState(rawAnswers, () => {
        checkSurveyState(this);
      });
    } else {
      // storeAnswer(index, this.state);
    }
  }

  componentDidUpdate(prevProps, prevState){
    // if (this.props?.rawAnswers?.value.length == 0 && 
    //   document.getElementById('singleTxt')?.value?.length > 0) {
    //     const { rawAnswers, checkSurveyState } = this.props;
    //     this.setState(rawAnswers, () => {
    //       checkSurveyState(this);
    //     });
    // }
    if (this.props?.rawAnswers?.value.length == 0 
      || ( prevState.value !== this.state.value 
      && document.getElementById('singleTxt'))){
      document.getElementById('singleTxt').value = this.props?.rawAnswers?.value || '';
    }
  }

  handleChange(e) {
    const { storeAnswer, questionId } = this.props;
    const value = e.target.value;
    this.setState({ value }, () => {
      storeAnswer(questionId, this.state, this.isQuestionAnswered(), undefined, undefined, this.isQuestionAnswered());
    });
  }

  isQuestionAnswered = () => {
    return !!this.state.value;
  };

  render() {
    const { text, question, className } = this.props;

    return (
      <div className={`${className}`}>
        <Element type="p" fontFamily="GTAM" fontSize="14px">
          {ReactHtmlParser(question)}
        </Element>
        <div className="row surveys-container collapse">
          <div className="surveys-list small-12 columns">
            {text.label && (
              <div className={`survey-label survey-item-${text.size}`}>
                {text.label}
              </div>
            )}
            <input
              id='singleTxt'
              type="text"
              onChange={this.handleChange}
              value={this.state.value}
              className={`survey-text survey-item-${text.size}`}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default SingleText;
